import moment from 'moment-timezone'
import _ from 'lodash'
import t from 'typy'
import Datepicker from 'vuejs-datepicker'

export default {
	components: {
		Datepicker
	},
	data() {
		return {
			submit_btn: '',
			error_msg: '',
			info_msg: '',
			post_script_note_msg: '',
			facility_id: null,
			date_from: '',
			date_to: '',
		}
	},
	async mounted() {
		this.facility_id = window._app_facility.id
	},
	methods: {
		async submitForm(e) {
			e.preventDefault()

			if (this.submit_btn == 'submit') {
				// console.log(moment.parseZone(this.selectedDate).utc())
				const timezone = moment.tz.guess()
				const d = await this.$lionheart
				.post('/log/ids-downloads', {
					date_from: moment(this.date_from).format('YYYY-MM-DD HH:mm:ss'),
					date_to: moment(this.date_to).format('YYYY-MM-DD HH:mm:ss'),
					facility_id: this.facility_id,
					language: this.$i18n.locale
				}, {responseType: 'arraybuffer'})
				.then(r => {
					if (r.headers['content-type'] == 'application/json') {
						this.error_msg = '';
						this.info_msg = this.$t('download.info_message');
					} else {
						const fromDate = moment(this.date_from).format('YYYY-MM-DD');
						const toDate = moment(this.date_to).format('YYYY-MM-DD');
						const nonce = Date.now().toString(36);
						const file = `passports_${fromDate}_to_${toDate}-${nonce}.zip`;

						let blob = new Blob([r.data], { type: 'application/zip' });
						const downloadUrl = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
	
						link.href = downloadUrl;
						link.setAttribute('download', file); //any other extension
	
						document.body.appendChild(link);
	
						link.click();
						link.remove();

						this.info_msg = '';
						this.info_msg = this.$t('account-page-downloads.post-script-note-normal-type');
					}

			        return {
			        	error: {
			        		has_error: false
			        	}
			        }
				}).catch(e => {
					const response = e.response;
					console.log('Something went wrong.');
					if (response.status == 413) {
						try {
							const text = new TextDecoder('utf-8').decode(response.data); 
							this.error_msg = JSON.parse(text).message;
							console.log(text);
						} catch(e) {
							this.error_msg = this.$t('download.error_content_too_large');
						}
					} else {
						this.catcher(e);
					}
				})
				
				if (e.error.has_error) return this.errorDisplay(d)
			}
		},
		errorDisplay(d) {
			this.error_msg = this.$t('download.error_message')
			setTimeout(() => window.scrollTo(0, $('#error_msg').position().top - 10), 300)
			return
		},
		isFormValuesValid() {
			// DateTime (string) -> UTC (int) then compared inversely. Why? Because v-bind:disabled follows opposite logic, that's why!
			return !(new Date(this.date_from).getTime() <= new Date(this.date_to).getTime())
		}
	}
}
